<template>
	<div class="p-grid">
		<div class="p-col-12">
			<p class="login-text" style="font-weight: bold; text-align: center; ">The TiroLibre Solutions</p>
		</div>
		<div class="p-col-12 p-lg-4">
			<img :src="commonService.getHomePlayerImageUrl()" alt="" style="width: 55%; display: block; margin: auto;">
			<div class="p-grid" style="margin-top: 10px;">
				<div class="p-col-4">
				</div>
				<div class="p-col-4">
					<Button label="Players" class="p-button-warning" style="color: white; font-weight: bold;" @click="homePlayer" />
				</div>
			</div>
		</div>
		<div class="p-col-12 p-lg-4">
			<img :src="commonService.getHomeTeamImageUrl()" alt="" style="width: 50%; display: block; margin: auto;">
			<div class="p-grid" style="margin-top: 10px;">
				<div class="p-col-4">
				</div>
				<div class="p-col-4">
					<Button label="Clubs" class="p-button-warning" style="color: white; font-weight: bold;" @click="homeClub" />
				</div>
			</div>
		</div>
		<div class="p-col-12 p-lg-4">
			<img :src="commonService.getHomeAgentImageUrl()" alt="" style="width: 40%; display: block; margin: auto;">
			<div class="p-grid" style="margin-top: 10px;">
				<div class="p-col-4">
				</div>
				<div class="p-col-4">
					<Button label="Agents" class="p-button-warning" style="color: white; font-weight: bold;" @click="homeAgent" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		homeClub() {
			this.$router.push("/homeClub");
		},
		homePlayer() {
			this.$router.push("/homePlayer");
		},
		homeAgent() {
			this.$router.push("/homeAgent");
		},
	},
};
</script>

<style scoped>
.login-text {
	margin-top: 10px;
	font-size: 19px;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>